export default "__VITE_ASSET__ar6qVUHV__"